import { marked } from "marked";
import DOMPurify from 'dompurify';
import { useOutletContext } from "react-router";

export default function About() {
  let { about } = useOutletContext();

  window.scrollTo(0, 0);

  return (
    <div id="about" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(marked.parse(about))}}>
    </div>
  )
}